import React from "react";

export default function ApiDocs() {
  // Note: this static HTML file is generated from our swagger API spec with redoc-cli
  // See frontend/README.md for details
  const STATIC_HTML_FILE_PATH = "/external-api-docs.html";

  return <iframe src={STATIC_HTML_FILE_PATH} width="100%" height="100%" />;
}
